<script>
	import { message, useStorage, user } from '$lib/stores';
	import { fly } from 'svelte/transition';
	import { onMount, tick } from 'svelte';
	import { _ } from 'svelte-i18n';

	let type = $message.type;
	let text = $message.text;
	let app = $message.app;

	let img = '/icons/check-icon.svg';
	let typeClass = type;

	if (type === 'error') {
		img = '/icons/error-icon.svg';
	} else if (type === 'warning') {
		img = '/icons/warning-icon.svg';
	} else if (type === 'info') {
		img = '/icons/info-icon.svg';
	}

	let modal;
	let mounted = false;

	let appAudio = useStorage('appAudio_' + $user, true);

	let successTimeout;
	let alertTimeout;

	onMount(async () => {
		mounted = true;

		if (app && $appAudio) {
			if (type === 'error' || type === 'warning') {
				let error = new Audio('/audio/error.wav');
				error.play();
			} else if (type === 'success' || type === 'info') {
				let success = new Audio('/audio/success.mp3');
				success.play();
			}
		}

		await tick();
		modal.focus({ focusVisible: false });

		if (type === 'success') {
			successTimeout = setTimeout(() => {
				$message.active = false;
			}, 3500);
		} else {
			alertTimeout = setTimeout(() => {
				$message.active = false;
			}, 7000);
		}
	});

	const closeModal = () => {
		$message.active = false;
		if (type === 'success') {
			clearTimeout(successTimeout);
		} else {
			clearTimeout(alertTimeout);
		}
	};
</script>

{#if mounted}
	<div
		transition:fly={{ y: app ? -100 : 100, duration: 700 }}
		class="w-full fixed {app ? 'top-12 z-[120]' : 'bottom-12 z-50'} pointer-events-none"
	>
		<div
			role={type === 'success' ? 'dialog' : 'alert'}
			class="message-modal {typeClass} relative w-96 max-w-[90%] mx-auto my-4 bg-green-100 text-green-900 border-green-900 border-2 rounded-lg py-4 pl-3 pr-4 flex gap-4 items-center shadow-xl pointer-events-auto"
			bind:this={modal}
			tabindex="-1"
			aria-labelledby="dialog-text"
		>
			<img src={img} alt="" class="w-7" />
			<div>
				<p id="dialog-text" class="leading-tight mt-[3px] text-lg whitespace-pre-wrap">
					{@html text}
				</p>
				{#if $message.errors?.length > 0}
					<ul class="mt-1 text-sm list-disc ml-5">
						{#each $message.errors as err}
							<li>{@html err}</li>
						{/each}
					</ul>
				{/if}
			</div>
			<button
				class="absolute top-0 right-0 p-2 rounded-md"
				on:click={closeModal}
				aria-label={$_('general.closeMsg')}
			>
				<svg
					width="12px"
					height="12px"
					viewBox="0 0 16 16"
					version="1.1"
					xmlns="http://www.w3.org/2000/svg"
					xmlns:xlink="http://www.w3.org/1999/xlink"
				>
					<g
						id="Page-1"
						stroke="none"
						stroke-width="1"
						fill="none"
						fill-rule="evenodd"
						stroke-linecap="round"
						stroke-linejoin="round"
					>
						<g
							id="cancel-01-stroke-rounded"
							transform="translate(1.000000, 1.000000)"
							stroke-width="1.5"
						>
							<path
								d="M14.0005,-0.00012 L0.00049,13.9999 M0.00049,-0.00012 L14.0005,13.9999"
								id="Shape"
							></path>
						</g>
					</g>
				</svg>
			</button>
		</div>
	</div>
{/if}

<style>
	svg g {
		@apply stroke-green-900;
	}

	.message-modal:focus {
		outline: none;
	}

	.message-modal:global(.error) {
		@apply bg-red-100 text-red-900 border-red-900;
	}

	.message-modal:global(.error) svg g {
		@apply stroke-red-900;
	}

	.message-modal:global(.info) {
		@apply bg-blue-100 text-blue-900 border-blue-900;
	}

	.message-modal:global(.info) svg g {
		@apply stroke-blue-900;
	}

	.message-modal:global(.warning) {
		@apply bg-yellow-100 text-yellow-900 border-yellow-900;
	}

	.message-modal:global(.warning) svg g {
		@apply stroke-yellow-900;
	}
</style>
